/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyInternshipRejectionDTO
 */
export interface CompanyInternshipRejectionDTO {
	/**
	 *
	 * @type {string}
	 * @memberof CompanyInternshipRejectionDTO
	 */
	message?: string | null;
}

export function CompanyInternshipRejectionDTOFromJSON(
	json: any
): CompanyInternshipRejectionDTO {
	return CompanyInternshipRejectionDTOFromJSONTyped(json, false);
}

export function CompanyInternshipRejectionDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CompanyInternshipRejectionDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		message: !exists(json, "message") ? undefined : json["message"],
	};
}

export function CompanyInternshipRejectionDTOToJSON(
	value?: CompanyInternshipRejectionDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		message: value.message,
	};
}
